import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getDetailFilm, getListFilm } from "../../services/getDetailFilm";
import { Collapse, Divider, Skeleton } from "antd";
import "./PlayFilm.scss";
import Hls from "hls.js";
import { Helmet } from "react-helmet";

function PlayFilm() {
  const [data, setData] = useState(null);
  const [suggestedMovies, setSuggestedMovies] = useState([]);
  const params = useParams();
  const id = params.id;

  const [selectedServer, setSelectedServer] = useState(0);
  const [selectedEpisodes, setSelectedEpisodes] = useState(0);

  const fetchApi = async () => {
    const res = await getDetailFilm(id);
    setData(res);
  };

  const fetchSuggestedMovies = async () => {
    const res = await getListFilm();
    if (res && res.items) {
      const shuffled = res.items.sort(() => 0.5 - Math.random());
      const selected = shuffled.slice(0, 15);
      setSuggestedMovies(selected);
    }
  };

  useEffect(() => {
    fetchApi();
    fetchSuggestedMovies();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  useEffect(() => {
    if (
      data &&
      data.episodes &&
      data.episodes.length > 0 &&
      data.episodes[selectedServer].server_data[selectedEpisodes]
    ) {
      const videoLink =
        data.episodes[selectedServer].server_data[selectedEpisodes].link_m3u8;

      if (videoLink && Hls.isSupported()) {
        const video = document.getElementById("video");
        const hls = new Hls();
        hls.loadSource(videoLink);
        hls.attachMedia(video);
        video.muted = false;
        video.volume = 1;

        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          video.play().catch((e) => {
            console.warn("Chưa click tương tác nên chưa tự play được");
          });
        });

        return () => hls.destroy();
      }
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [data, selectedServer, selectedEpisodes]);

  if (!data)
    return (
      <div className="row">
        <div className="col-12">
          <Skeleton active paragraph={{ rows: 18 }} />
        </div>
      </div>
    );

  return (
    <>
      <Helmet>
        <title>
          {data ? `${data.movie.name} | ` : "Đang tải..."}
        </title>
        <script type='text/javascript' src='//rampcreeper.com/88/76/82/887682c969e012bb65b69e0178039181.js'></script>
      </Helmet>

      <div className="playFilm">
        {/* Thông báo chạy chữ */}
        <div className="playFilm__notice">
          <marquee scrollamount="5">
            Donet Vào Ví MOMO 0886089902 Tên SAN A SAM - Để Có Kinh Phí Duy Trì server Nhé - Kết Nối Wifi Để Trải Nghiệm Tốt Hơn Nhé
          </marquee>
        </div>

        <div className="playFilm__main">
          <h1>{data.movie.title}</h1>
          <div className="playFilm__screen">
            <video autoPlay id="video" width="100%" controls>
              Trình duyệt của bạn không hỗ trợ video.
            </video>
          </div>
        </div>

        <div className="playFilm__server-group">
          {data.episodes.map((server, serverIndex) => (
            <button
              key={serverIndex}
              className={`server-btn ${
                selectedServer === serverIndex ? "active" : ""
              }`}
              onClick={() => {
                setSelectedServer(serverIndex);
                setSelectedEpisodes(0);
              }}
            >
              {server.server_name}
            </button>
          ))}
        </div>

        <div className="playFilm__episodes">
          <ul>
            {data.episodes[selectedServer].server_data.map((item, epIndex) => (
              <li
                key={epIndex}
                className={
                  epIndex === selectedEpisodes
                    ? "selected__episodes"
                    : "no-selected__episodes"
                }
                onClick={() => setSelectedEpisodes(epIndex)}
              >
                {item.name}
              </li>
            ))}
          </ul>
        </div>

        <div className="playFilm__name">
          <span>
            {data.movie.name}:{" "}
            {data.episodes[selectedServer].server_data.length > 1 ? (
              <>Tập {selectedEpisodes + 1}</>
            ) : (
              <>{data.episodes[selectedServer].server_data[0].name}</>
            )}
          </span>
          <Collapse
            items={[
              {
                key: "1",
                label: "Nội dung chi tiết",
                children: <p>{data.movie.content}</p>,
              },
            ]}
          />
        </div>

        <Divider>Đề xuất phim</Divider>
        <div className="playFilm__suggested">
          {suggestedMovies.map((movie, index) => (
            <Link
              to={`/play-film/${movie.slug}`}
              key={index}
              className="suggested__item"
            >
              <img src={movie.poster_url} alt={movie.name} />
              <p>{movie.name}</p>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}

export default PlayFilm;
